
import { RoleTypesEnum } from '@app/@core/enums';
import { HomeSelectionEnum } from '@app/@core/enums/home-selection.enum';
import { environment } from '@env/environment';
import { MenuItemModel } from '@shared/models/menu.model';
import { MenuRoles } from './menu-roles';

export const HeaderMenus: MenuItemModel[] = [
  {
    name: 'HEADER_MENU.HOME.TITLE',
    order: 1,
    route: environment.tempUrl,
    event: { type: 'homeSelection', value: HomeSelectionEnum.MainPanel },

    child: [
      {
        name: 'HEADER_MENU.HOME.MAIN_PANEL',
        route: environment.tempUrl,
        order: 1,
        event: { type: 'homeSelection', value: HomeSelectionEnum.MainPanel }
      },
      {
        name: 'HEADER_MENU.HOME.FACILITY_MANAGEMENT',
        route: environment.tempUrl + '/facilitybuilding/management',
        order: 2,
        event: { type: 'homeSelection', value: HomeSelectionEnum.FacilityManager }
      },
      {
        name: 'HEADER_MENU.PRODUCTIVITY.MAP',
        route: environment.tempUrl + '/maps',
        order: 3,
        event: { type: 'homeSelection', value: HomeSelectionEnum.Map }
      },
    ]
  },
  {
    name: 'HEADER_MENU.REAGENT.TITLE',
    route: '',
    order: 2,
    child: [
      {
        name: 'HEADER_MENU.REAGENT.REACTIVE_RATES',
        route: environment.tempUrl + '/reactiveRates',
        order: 1,
        externalUrl: true
      },
      {
        name: 'HEADER_MENU.REAGENT.STEP_MAINTENANCE',
        route: environment.tempUrl + '/stepMaintenance',
        order: 2,
        externalUrl: true
      },
    ]
  },
  {
    name: 'HEADER_MENU.QUALITY.TITLE',
    route: '',
    order: 3,
    child: [
      {
        name: 'HEADER_MENU.QUALITY.ENERGY_QUALITY',
        route: environment.tempUrl + '/energyQuality',
        order: 1,
        externalUrl: true
      },
      {
        name: 'HEADER_MENU.QUALITY.FACILITY_REPORT',
        route: environment.tempUrl + '/facilityReport',
        order: 2,
        role: MenuRoles.FacilityReport,
        externalUrl: true
      },
    ]
  },
  {
    name: 'HEADER_MENU.PRODUCTIVITY.TITLE',
    route: '',
    order: 4,
    child: [

      {
        name: 'HEADER_MENU.PRODUCTIVITY.CONSUMPTION_SUMMARY',
        route: 'consumptionSummary',
        order: 2,
      },
      {
        name: 'HEADER_MENU.PRODUCTIVITY.ENERGY_COMPARISON',
        route: environment.tempUrl + '/energyComparison',
        order: 3,
        role: MenuRoles.EnergyComparison,
        externalUrl: true
      },
      {
        name: 'HEADER_MENU.PRODUCTIVITY.METER_INDICES',
        route: 'meter-indices',
        order: 4
      }
    ]
  }
];
